import { PropTypes } from 'prop-types';
import copy from 'copy-to-clipboard';
import React from 'react';

import ProjectCard from '../project-card';
import typeTest from '../../../core/constants/testTypes';

import {
  ComponentSize,
  CopyComponent,
  Text,
} from './styles';

import {
  LINK_URL_TEXT,
  DEFAULT_TEXT,
} from './constants';

const RecruitLinkCard = (props) => {
  const {
    title,
    url,
    raw,
    testType,
  } = props;

  const onlyShowLinkUrlText = (type) => {
    if (type === typeTest.CARD_SORT || type === typeTest.TREE_TEST) {
      return true;
    }
    return false;
  };

  return (
    raw
      ? (
        <ComponentSize>
          <CopyComponent
            data-study-copy-ryo-link
            floated="right"
            readOnly
            action={{
              labelPosition: 'right',
              icon: 'copy outline',
              content: 'Copy',
              onClick: () => copy(url),
            }}
            defaultValue={url}
          />
        </ComponentSize>
      )
      : (
        <ProjectCard
          title={title}
        >
          {onlyShowLinkUrlText(testType) ? (
            <Text>{LINK_URL_TEXT}</Text>
          ) : (
            <Text>
              {DEFAULT_TEXT}
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://help.playbookux.com/en/articles/3263976-how-do-i-bring-my-own-customers-to-a-study"
              >
                here
              </a>
              .
            </Text>
          )}

          <ComponentSize>
            <CopyComponent
              data-study-copy-ryo-link
              floated="right"
              readOnly
              action={{
                labelPosition: 'right',
                icon: 'copy outline',
                content: 'Copy',
                onClick: () => copy(url),
              }}
              defaultValue={url}
            />
          </ComponentSize>
        </ProjectCard>
      )
  );
};

RecruitLinkCard.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  raw: PropTypes.bool,
  testType: PropTypes.string.isRequired,
};

RecruitLinkCard.defaultProps = {
  raw: false,
};

export default RecruitLinkCard;
